module.exports = __webpack_public_path__ + "img/d1sj-btn.2a05a078.png";